module.exports = __webpack_public_path__ + "static/image/ZJFY.7f4f055.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ZJFY.png
// module id = 101
// module chunks = 1